export default "__VITE_ASSET__CXoqoF6J__"